interface CycleLike {
  id: number;
  startAt?: string | Date | null;
  endAt?: string | Date | null;
}

const toIsoDate = (value?: string | Date | null) => {
  if (!value) return '';
  if (typeof value === 'string') return value.slice(0, 10);
  return value.toISOString().slice(0, 10);
};

export default function getCurrentReviewCycleId<T extends CycleLike>(
  cycles: T[],
): number | null {
  if (cycles.length === 0) return null;

  const today = new Date().toISOString().slice(0, 10);
  const containing = cycles.find((cycle) => {
    const startAt = toIsoDate(cycle.startAt);
    const endAt = toIsoDate(cycle.endAt);

    return startAt <= today && today <= endAt;
  });

  if (containing) return containing.id;

  const sortedByEndDesc = [...cycles].sort((a, b) =>
    toIsoDate(b.endAt).localeCompare(toIsoDate(a.endAt)),
  );

  return sortedByEndDesc[0]?.id ?? null;
}
